import React from "react";
import { TitleEnforcementList } from "../../components/title/TitleEnforcementList";
export var TitlesWithIsbnList = function () { return React.createElement(TitleEnforcementList, { withIsbn: true }); };
